import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Format message for WhatsApp
    const phoneNumber = '22377291138'; // WhatsApp format without +
    const message = `Bonjour, je suis ${formData.name} (${formData.email}).\n\n${formData.message}`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    
    // Open WhatsApp
    window.open(whatsappUrl, '_blank');
    
    // Reset form
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Contactez-nous</h2>
        <p className="section-subtitle">
          Une question ? Besoin d'aide ? N'hésitez pas à nous contacter
        </p>
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon">📧</div>
              <div>
                <h3>Email</h3>
                <p>
                  <a href="mailto:cheickm.sissoko@djammadev.com" className="contact-link">
                    cheickm.sissoko@djammadev.com
                  </a>
                </p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">📞</div>
              <div>
                <h3>Téléphone</h3>
                <p>
                  <a href="tel:+22377291138" className="contact-link">
                    +223 77 29 11 38
                  </a>
                </p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">💬</div>
              <div>
                <h3>WhatsApp</h3>
                <p>
                  <a 
                    href="https://wa.me/22377291138" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="contact-link"
                  >
                    +223 77 29 11 38
                  </a>
                </p>
              </div>
            </div>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Nom</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary">
              <span>💬</span>
              Envoyer via WhatsApp
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;

